import { EventEmitter, Injectable } from '@angular/core';
import { BaseDownloadServiceWithFilter } from './base.service';
import { ExpenseRequest } from '@cl/shared/models/expense-requests/expense-request.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NzImageService } from 'ng-zorro-antd/image';
import { lastValueFrom } from 'rxjs';
import { CommandResult } from '@cl/shared/models';
import { FileMetadata } from '@cl/shared/models/file.model';
import { ExpenseRequestFilter } from '@cl/shared/models/expense-requests/expense-request-filter.model';

@Injectable({
    providedIn: 'root',
})
export class ExpenseRequestsService extends BaseDownloadServiceWithFilter<ExpenseRequest, ExpenseRequestFilter> {
    loadingChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        httpClient: HttpClient,
        protected nzImageService: NzImageService,
    ) {
        super(httpClient, '/api/v1/expense-requests/', nzImageService);
    }

    async addExpenseRequestFile(expenseRequestFileFormData: FormData): Promise<void> {
        return await lastValueFrom(this.httpClient.post<void>(`${this.baseApiUrl}expense-request-file`, expenseRequestFileFormData));
    }

    async downloadExpenseRequestFile(downloadExpenseRequestFileParams: HttpParams): Promise<void> {
        return this.handleFileDownloading(
            lastValueFrom(
                this.httpClient.get<CommandResult<FileMetadata>>(`${this.baseApiUrl}download-file`, { params: downloadExpenseRequestFileParams }),
            ),
        );
    }

    async getExpenseRequestFileMetadata(expenseRequestId: number, expenseRequestFileId: number): Promise<CommandResult<FileMetadata>> {
        const params = new HttpParams().append('expenseRequestId', expenseRequestId).append('expenseRequestFileId', expenseRequestFileId);

        return await lastValueFrom(this.httpClient.get<CommandResult<FileMetadata>>(`${this.baseApiUrl}download-file`, { params }));
    }

    async deleteExpenseRequestFile(expenseRequestId: number, expenseRequestFileId: number): Promise<void> {
        return await lastValueFrom(
            this.httpClient.delete<void>(`${this.baseApiUrl}expense-request-file/${expenseRequestId}/${expenseRequestFileId}`),
        );
    }

    async previewExpenseRequestApprovalFile(expenseRequestId: number): Promise<CommandResult<FileMetadata>> {
        return this.handleFileDownloading(
            lastValueFrom(this.httpClient.get<CommandResult<FileMetadata>>(`${this.baseApiUrl}${expenseRequestId}/preview-approval-file`)),
        );
    }

    async downloadExpenseReqeuestApprovalFile(expenseRequestId: number): Promise<CommandResult<FileMetadata>> {
        return this.handleFileDownloading(
            lastValueFrom(this.httpClient.get<CommandResult<FileMetadata>>(`${this.baseApiUrl}${expenseRequestId}/download-approval-file`)),
        );
    }

    async getExpenseRequestApprovalFileMetadata(expenseRequestId: number): Promise<CommandResult<FileMetadata>> {
        return await lastValueFrom(this.httpClient.get<CommandResult<FileMetadata>>(`${this.baseApiUrl}${expenseRequestId}/download-approval-file`));
    }

    async changeStatus(params: HttpParams): Promise<void> {
        return await lastValueFrom(this.httpClient.patch<void>(`${this.baseApiUrl}change-status`, null, { params: params }));
    }
}
